import { connect } from 'react-redux';
import { expandAndFocusCommentPanel } from '../../../../DeviationPage/redux/actions';
var mapStateToProps = function (state) { return ({}); };
var mapDispatchToProps = {
    expandAndFocusCommentPanel: expandAndFocusCommentPanel,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=PrimaryDesktopActionBar.container.js.map